import React from 'react';

export const MoveToWholeSale = ({ color }) => {
  return (
    <svg
      width="25"
      height="28"
      viewBox="0 0 25 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="move wholesale">
        <path
          id="Vector"
          d="M13.7168 20.6372H9.78345"
          stroke={color}
          strokeWidth="1.64"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_2"
          d="M5.17435 20.948H1.85205V17.6276C1.85205 16.4372 3.19215 15.4724 4.84491 15.4724H20.1546C21.8082 15.4724 23.1483 16.4372 23.1483 17.6276V20.948H19.2459"
          stroke={color}
          strokeWidth="1.64"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_3"
          d="M3.70312 15.4726L5.75866 11.467C5.93265 11.1273 6.31771 10.9097 6.7427 10.9097H15.4098C15.7711 10.9097 16.1086 11.0682 16.3083 11.3321L19.4439 15.4726"
          stroke={color}
          strokeWidth="1.64"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_4"
          d="M11.1106 10.9097V15.4726"
          stroke={color}
          strokeWidth="1.22222"
          strokeMiterlimit="10"
        />
        <g id="Group 1171275224">
          <path
            id="Vector_5"
            d="M9.94798 21.1631C9.95862 21.2639 9.96435 21.3664 9.96435 21.4698C9.96435 22.9565 8.82928 24.1616 7.42907 24.1616C6.02886 24.1616 4.8938 22.9565 4.8938 21.4698C4.8938 21.3664 4.89953 21.2639 4.91017 21.1631"
            stroke={color}
            strokeWidth="1.64"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_6"
            d="M4.8938 21.1631C5.03794 20.0383 6.11778 19.1641 7.42907 19.1641C8.74036 19.1641 9.8202 20.0383 9.96435 21.1631"
            stroke={color}
            strokeWidth="1.64"
            strokeMiterlimit="10"
          />
        </g>
        <g id="Group 1171275223">
          <path
            id="Vector_7"
            d="M19.0744 21.1631C19.0851 21.2639 19.0908 21.3664 19.0908 21.4698C19.0908 22.9565 17.9557 24.1616 16.5555 24.1616C15.1553 24.1616 14.0203 22.9565 14.0203 21.4698C14.0203 21.3664 14.026 21.2639 14.0366 21.1631"
            stroke={color}
            strokeWidth="1.64"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_8"
            d="M14.0203 21.1631C14.1644 20.0383 15.2442 19.1641 16.5555 19.1641C17.8668 19.1641 18.9467 20.0383 19.0908 21.1631"
            stroke={color}
            strokeWidth="1.64"
            strokeMiterlimit="10"
          />
        </g>
        <path
          id="Vector_9"
          d="M5.03718 1.22808L16.719 3.46502C18.2305 3.75445 19.2195 5.19934 18.9259 6.68908C18.6322 8.17882 17.1662 9.1536 15.6547 8.86416L3.97287 6.62723C3.66153 6.56761 3.45813 6.27046 3.51862 5.96359L4.36385 1.67579C4.42434 1.36893 4.72583 1.16846 5.03718 1.22808Z"
          stroke={color}
          strokeWidth="1.22"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_10"
          d="M16.4161 7.8387C17.0437 7.8387 17.5525 7.33757 17.5525 6.7194C17.5525 6.10122 17.0437 5.6001 16.4161 5.6001C15.7886 5.6001 15.2798 6.10122 15.2798 6.7194C15.2798 7.33757 15.7886 7.8387 16.4161 7.8387Z"
          stroke={color}
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          id="Vector_11"
          d="M15.8925 10.9097C14.7726 7.27997 17.0449 6.71997 17.0449 6.71997"
          stroke={color}
          strokeWidth="0.407407"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          id="Vector_12"
          d="M18.5178 7.25928C18.5178 7.25928 18.6208 9.77389 15.7405 10.9096"
          stroke={color}
          strokeWidth="0.407407"
          strokeMiterlimit="10"
        />
      </g>
    </svg>
  );
};
